const CheckedIcon = ({ size = 56, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect x="0.965517" y="0.965517" width="54.069" height="54.069" rx="27.0345" fill="#68B77C" fillOpacity="0.3" />
      <rect
        x="0.965517"
        y="0.965517"
        width="54.069"
        height="54.069"
        rx="27.0345"
        stroke="url(#paint0_linear_887_73117)"
        strokeWidth="1.93103"
      />
      <path
        d="M38 21.5L24.25 35.25L18 29"
        stroke="#37ED64"
        strokeWidth="4.82759"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_887_73117"
          x1="3.95297"
          y1="4.40429"
          x2="50.7637"
          y2="54.4557"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#26D752" />
          <stop offset="1" stopColor="#26D752" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CheckedIcon;
